<template>
    <div class="input_price">
        <div class="close_box margin_r">
            <span class="close_icon" @click="clear">x</span>
        </div>
        <md-field>
            <label v-if="valuePlaceholder">{{ $t(valuePlaceholder) }}</label>
            <label v-else>{{$t("common.price")}}</label>
            <MoneyAmountInput v-model="params.data[params.colDef.field]"></MoneyAmountInput>
        </md-field>
    </div>
</template>
<script>
import MoneyAmountInput from "@/components/templates/common/MoneyAmountInput";

export default {
  components: {
    MoneyAmountInput
  },
  computed: {
    valuePlaceholder() {
      return this.params.valuePlaceholder;
    }
  },
  methods: {
    clear() {
      this.params.data[this.params.colDef.field] = null;
    }
  }
};
</script>

<style lang="scss" scoped>
    .input_price {
        width: 100%;
        display: flex;
        justify-content: space-between;
        align-items: center;

        i {
            font-size: 13px;
        }

        .close_box,
        .fa_box {
            height: 21px;
            width: 32px;
            text-align: center;
            line-height: 21px;
            border-radius: 4px;
            cursor: pointer;
        }

        .close_box {
            .close_icon {
                display: inline-block;
                width: 21px;
                height: 21px;
                text-align: center;
                border-radius: 4px;
                line-height: 16px;
                border: 1px solid #b5b6b7;
            }

            .close_icon:hover {
                border: 1px solid #7c7f83;
            }
        }
    }
</style>